import { RouteObject } from 'react-router-dom';
import { RouteMeta } from '@/pages/routes';
import EmailTemplates from '@/modules/settings/pages/EmailTemplates.tsx';
import { SiteGroup } from 'shared/enums.ts';

const route: RouteObject = {
	path: 'settings',
	loader: () => ({
		meta: {
			title: 'Settings',
			disabled: true,
		} as RouteMeta,
	}),
	lazy: async () => ({ Component: (await import('@/modules/propertyDocument/settings/Layout')).default }),
	children: [
		{
			path: 'website',
			index: true,
			id: 'propertyDocumentWebsite',
			loader: () => ({
				meta: {
					title: 'Website',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/propertyDocument/settings/pages/Website')).default }),
		},
		{
			path: 'crm',
			index: true,
			id: 'propertyDocumentCrm',
			loader: () => ({
				meta: {
					title: 'CRM',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/propertyDocument/settings/pages/Crm')).default }),
		},
		{
			path: 'products',
			index: true,
			id: 'propertyDocumentProducts',
			loader: () => ({
				meta: {
					title: 'Products',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/propertyDocument/settings/pages/Products')).default }),
		},
		{
			id: 'propertyDocumentEmailTemplates',
			index: true,
			path: 'templates/email',
			element: <EmailTemplates group={SiteGroup.PropertyDocument} />,
			loader: () => ({
				meta: {
					title: 'Email Templates',
					disabled: true,
				} as RouteMeta,
			}),
		},
	],
};
export default route;
